import React, { useContext } from 'react';
import CollapseText from '@catalogo/theme-collapse-text';
import { context } from '../../../context';
import { ReviewContainer, SignatureContainer, Wrapper } from './Styled';
import { Signature, Margin, Stamp, LikeDislike } from '../../atoms';
import { RatingStars } from '../RatingStars';
import { useFormatDate } from '../../../hooks';
import { withReviewSkoob } from '../../../hocs';

const Review = (props: any) => {
  const {
    isSkoob,
    id,
    review,
    date,
    owner,
    rating,
    downVotes,
    upVotes,
    isVerifiedPurchaser,
    maxReviewLength,
    dispatchMetrics,
  } = props;
  const { description, title } = review;
  const { config } = useContext<any>(context);
  const { brand, brandName } = config;
  const formatDate = useFormatDate(date);
  const defaultEmptyReview = 'O cliente avaliou o produto, mas não escreveu um comentário.';
  const userReview = description || defaultEmptyReview;
  const stampLabel = isVerifiedPurchaser && <Stamp brand={brand} isSkoob={!!isSkoob} />;
  const metricContent = {
    category: 'avaliacao-pdp',
  };
  const metric = (collapseActive: boolean) => {
    const action = collapseActive ? 'ver-mais-comentario' : 'ver-menos-comentario';
    dispatchMetrics('event:track', { ...metricContent, action });
  };

  return (
    <Wrapper>
      <ReviewContainer>
        <h4>{title}</h4>
        <Margin top={15} />
        <RatingStars size={16} rating={rating} />
        <Margin bottom={15} />
        <CollapseText text={userReview} maxTextLength={maxReviewLength} defaultTextHeight={70} onChange={metric} />
        <SignatureContainer>
          <Signature user={owner.name} authorId={owner.id} date={formatDate} brandName={brandName} />
          {stampLabel}
        </SignatureContainer>
      </ReviewContainer>
      <LikeDislike id={id} negativeFeedback={downVotes} positiveFeedback={upVotes} />
    </Wrapper>
  );
};

Review.defaultProps = {
  title: '',
  review: '',
  date: '',
  user: '',
  authorId: '',
  rating: '',
  negativeFeedback: 0,
  positiveFeedback: 0,
  isVerifiedPurchaser: false,
  brand: '',
  brandName: '',
  maxReviewLength: 340,
  id: '',
};

const ReviewSkoob = withReviewSkoob(Review);

export default Review;
export { Review, ReviewSkoob };
